import PGlobal from './PGlobal';
import PSprite from './PSprite';
import ObjectPool from './ObjectPool';
import AudioTrk from './AudioTrk';
import TipsWidget from './component/TipsWidget';
import Keyboard from './keyboard';
import DataModel from './DataModel';
import AudioConst from './AudioConst';

const TRK_DURATION_MIN  = 0.2;
const TIP_Y = - 3;

export default class AudioTrks extends PSprite {
    constructor() {
        super();
        this._interval = 0;
        this.pageStart = 0;
        this.selected = [];
        this.preSelected = [];
        this.trks = null;
        // normal, stretch_left, stretch_right, move
        this.status = "normal";

        this.canvas = new PIXI.Container();
        this.addChild(this.canvas);
        this.pool = new ObjectPool();
        this.shadowCanvas = new PIXI.Container();
        this.shadowCanvas.alpha = 0.6;
        this.addChild(this.shadowCanvas);

        this.tipsWidget = null;
        this.startMoveX = 0;
        this.hoverTimeout = null;
        
        this.cutTrkMouse = null;
        this.cutTrkPointer = null;
        this.trksIsOver = false;
        this.mounsePosition = new PIXI.Point();
        
        this.canvas.interactive = true;
        this.canvas.on('mouseover', (e) => this.onTraksMouseOver(e));
        this.canvas.on('mouseout', (e) => this.onTraksMouseOut(e));
        this.canvas.on('mousemove', (e) => this.onTraksMouseMove(e));

        this.shift = new Keyboard(16);
        this.del = new Keyboard(46);
        this.del.release = () => {if(PGlobal.hasFocus) {this.removeSelected();}};
        this.backspace = new Keyboard(8);
        this.backspace.release = () => {if(PGlobal.hasFocus) {this.removeSelected();}};
        this.c = new Keyboard(67);
        this.c.press = () => this.cIsDown();
        this.c.release = () => this.cIsUp();
        this.d = new Keyboard(68);
        this.a = new Keyboard(65);
        
        // 左右方向键移动选中的音轨片段
        this.arrowLeft = new Keyboard(37);  // 左方向键
        this.arrowLeft.press = () => {if(PGlobal.hasFocus) {this.startKeyMove(-1);}};
        this.arrowLeft.release = () => {if(PGlobal.hasFocus) {this.stopKeyMove();}};
        this.arrowRight = new Keyboard(39); // 右方向键
        this.arrowRight.press = () => {if(PGlobal.hasFocus) {this.startKeyMove(1);}};
        this.arrowRight.release = () => {if(PGlobal.hasFocus) {this.stopKeyMove();}};
        
        // 键盘移动相关状态
        this.keyMoveDirection = 0;  // 0=不移动, -1=向左, 1=向右
        this.keyMoveTimer = null;   // 移动定时器
        this.keyMoveInterval = 200;  // 移动间隔（毫秒）值越小移动越快

        this._range = new DataModel({
            min : 0,
            max : Infinity,
        });
        this._range.on("min", this.dirty, this);
        this._range.on("max", this.dirty, this);
        this.maxWidth = 0;
    }

    get range(){
        return this._range;
    }

    setData(data) {
        // this.pageStart = data.pagestart ? data.pagestart : 0;
        this.pageStart = 0;
        this.preSelected = data.selectedList ? data.selectedList : [];
        this.trks = data.trks;
        // if(data.trk) {
        //     this.trks = JSON.parse(data.trk);
        // }else {
        //     this.trks = null;
        // }
        this._updateWidth();
        this.dirty();
    }

    _updateWidth(){
        const parts = this.trks && this.trks.parts;
        if(!parts || parts.length === 0){ 
            this.maxWidth = 0;
            return;
        }
        const max = parts.reduce((max, trk)=>{return Math.max(max, trk.end);}, 0);
        this.maxWidth = (max - this.pageStart) * this._interval;
    }

    getWidth(){
        return this.maxWidth;
    }
    //鼠标上浮到音轨
    onTraksMouseOver(e) {
        this.trksIsOver = true;
        this.mounsePosition = e.data.getLocalPosition(this);
        //
        if(this.c.isDown) {
            this.showCutTrkMouse(true);
        }
    }
    //鼠标移出音轨
    onTraksMouseOut(e) {
        this.trksIsOver = false;
        this.showCutTrkMouse(false);
    }
    //鼠标在音轨上移动
    onTraksMouseMove(e) {
        if(this.trksIsOver) {
            this.mounsePosition = e.data.getLocalPosition(this);
            //
            if(this.cutTrkMouse) {
                this.cutTrkMouse.x = this.mounsePosition.x;
            }
            //
            if(this.cutTrkPointer) {
                this.cutTrkPointer.x = this.mounsePosition.x;
            }
        }
        
    }
    //C键按下
    cIsDown() {
        this.canvas.cursor = "none";
        if(this.trksIsOver) {
            this.showCutTrkMouse(true);
        }
    }
    //C键抬起
    cIsUp() {
        this.canvas.cursor = "auto";
        this.showCutTrkMouse(false);
    }
    //显示或隐藏剪切鼠标
    showCutTrkMouse(isShow) {
        if(isShow){
            //鼠标
            if(this.cutTrkMouse == null){
                const texture = PGlobal.resources.mainUI.textures['track_icon_cut'];
                this.cutTrkMouse = new PIXI.Sprite(texture);
                this.cutTrkMouse.interactive = false;
                this.addChild(this.cutTrkMouse);
                this.cutTrkMouse.x = this.mounsePosition.x;

            }
            //线
            if(this.cutTrkPointer == null){
                this.cutTrkPointer = new PIXI.Graphics();
                this.cutTrkPointer.beginFill(0xFFFFFF);
                this.cutTrkPointer.drawRect(0, 0, 1, AudioConst.DAIL_H + AudioConst.AUDIO_STEP_H);
                this.cutTrkPointer.endFill();
                this.addChild(this.cutTrkPointer);
                this.cutTrkPointer.x = this.mounsePosition.x;
                this.cutTrkPointer.y = -(AudioConst.DAIL_H + AudioConst.AUDIO_STEP_H);
            }
        } else {
            //鼠标
            this.removeChild(this.cutTrkMouse);
            this.cutTrkMouse = null;
            //线
            this.removeChild(this.cutTrkPointer);
            this.cutTrkPointer = null;
        }
    }

    redraw() {
        this.clear();
        if(this.trks && this.trks.parts.length) {
            let len = this.trks.parts.length;
            for(let i=0; i < len; ++i) {
                let data = this.trks.parts[i];
                data.index = i;
                let selected = this.preSelected.indexOf(i) >= 0;
                let trk = this.getTrk(data, selected);
                trk.range = this._range;
                if(selected) {
                    this.selected.push(trk);
                }
                this.canvas.addChild(trk);
            }
        }
    }

    clear() {
        this.selected.length = 0;
        let len = this.canvas.children.length;
        while(--len > -1) {
            let trk = this.canvas.getChildAt(len);
            this.canvas.removeChild(trk);
            this.pool.push("trk", trk);
        }
        this.clearShadow();
    }

    clearShadow() {
        this.shadowCanvas.x = 0;
        let len = this.shadowCanvas.children.length;
        while(--len > -1) {
            let trk = this.shadowCanvas.getChildAt(len);
            this.shadowCanvas.removeChild(trk);
            this.pool.push("trk", trk);
        }
    }

    getTrk(data, selected) {
        let trk = this.pool.pop("trk");
        if(!trk) {
            trk = new AudioTrk();
            trk.interval = this._interval;
            trk.setHeight(AudioConst.AUDIO_TRK_H);
            //trk.y = 0;
            trk.on('click', (e) => this.onTrkClick(e));
            trk.on('mouseover', (e) => this.onTrkOver(e));
            trk.on('mouseout', (e) => this.onTrkOut(e));
            trk.on('mousemove', (e) => this.onTrkMove(e));
            trk.on('mousedown', (e) => this.onTrkDown(e));
            trk.on('mouseup', (e) => this.onTrkUp(e));
            trk.on('mouseupoutside', (e) => this.onTrkUp(e));
        }
        trk.interactive = true;
        trk.data = data;
        trk.selected = selected;
        trk.x = (data.start-this.pageStart)*this._interval;

        return trk;
    }

    select(trk) {
        this.unselectAll();
        this.selected.push(trk);
        trk.selected = true;
    }

    addSelect(trk) {
        if(this.selected.indexOf(trk) < 0) {
            this.selected.push(trk);
            trk.selected = true;
        }
    }

    unselect(trk) {
        let index = this.selected.indexOf(trk);
        if(index >= 0){
            this.selected.splice(index, 1);
            trk.selected = false;
        }
    }

    unselectAll() {
        let len = this.selected.length;
        while(--len > -1) {
            this.unselect(this.selected[len]);
        }
    }

    /**
     * 全选当前音轨上的所有片段
     */
    selectAll() {
        this.unselectAll();
        const len = this.canvas.children.length;
        for(let i = 0; i < len; i++) {
            const trk = this.canvas.getChildAt(i);
            if(trk && trk.data) {
                this.addSelect(trk);
            }
        }
        console.log(`全选音轨片段，共选中 ${this.selected.length} 个片段`);
    }

    onTrkClick(e) {
        let trk = e.target;
        if(trk) {
            if(this.c.isDown) {
                let p = e.data.getLocalPosition(this.canvas);
                let pos = p.x / this._interval + this.pageStart;
                PGlobal.m.send(SCENE, 6, 38, new proto.com.proto.s.MFloat([pos]));
            }else if(this.d.isDown) {
                this.unselectAll();
                let right = this.canvas.getChildIndex(trk);
				let len = this.canvas.children.length;
				for(let r=right; r < len; ++r) {
					let rightp = this.canvas.getChildAt(r);
					this.addSelect(rightp);
				}
            }else if(this.a.isDown) {
                this.unselectAll();
                let left = this.canvas.getChildIndex(trk);
				for(let i=left; i >= 0; --i) {
					let leftp = this.canvas.getChildAt(i);
					this.addSelect(leftp);
				}
            }else if(this.shift.isDown) {
                if(trk.selected) {
                    this.unselect(trk);
                }else {
                    this.addSelect(trk);
                }
            }else if(this.selected.length > 1){
                this.select(trk);
            }else if(trk.selected) {
                this.unselect(trk);
            }else {
                this.select(trk);
            }
        }
    }

    onTrkOver(e) {
        let trk = e.target;
        if(this.status == "normal" && this.selected.length == 1 && trk.selected) {
            let p = e.data.getLocalPosition(trk);
            if(p.x > 0 && p.x <= 3) {
                trk.stretchMode = true;
            }else if(p.x >= trk.getWidth()-3 && p.x < trk.getWidth()) {
                trk.stretchMode = true;
            }else {
                trk.stretchMode = false;
            }
        }
    }

    onTrkOut(e) {
        let trk = e.currentTarget;
        if(trk && this.status == "normal" && trk.selected) {
            trk.stretchMode = false;
            this.hideShadow();
        }
        this.hideTipsInfo();
    }

    onTrkMove(e) {
        let trk = e.currentTarget;
        if(trk) {
            let p = e.data.getLocalPosition(trk);
            if(this.status == "normal"){ 
                if(p.x > 0 && p.x < trk.getWidth() && p.y > 0 && p.y < AudioConst.AUDIO_TRK_H){
                    this.hideTipsInfo();
                    const p2 = e.data.getLocalPosition(this);
                    this.startInfoTimeout(trk, p2.x);
                }
                if(trk.selected && this.selected.length == 1) {
                    if(p.x > 0 && p.x < 3) {
                        trk.stretchMode = true;
                    }else if(p.x >= trk.getWidth()-3 && p.x < trk.getWidth()) {
                        trk.stretchMode = true;
                    }else {
                        trk.stretchMode = false;
                    }
                }
            }else if(trk.selected){
                let canvasP = e.data.getLocalPosition(this.canvas);
                if(this.status == "move") {
                    if(this.shadowCanvas.children.length == 0) {
                        this.showShadow();
                        const p2 = e.data.getLocalPosition(this);
                        this.startMoveX = p2.x;
                        this.lastMoveP = canvasP;
                    }else {
                        // 计算期望的增量移动距离
                        const deltaMove = canvasP.x - this.lastMoveP.x;
                        const deltaChange = deltaMove / this._interval;
                        
                        // 获取当前累积的移动距离
                        const accumulatedChange = this.shadowCanvas.x / this._interval;
                        
                        // 检查碰撞（传入增量和累积移动量）
                        const collisionResult = this.checkCollision(this.selected, deltaChange, accumulatedChange);
                        
                        if(collisionResult.canMove) {
                            // 可以移动，使用实际可移动距离
                            const actualMove = collisionResult.actualChange * this._interval;
                            this.shadowCanvas.x += actualMove;
                            this._showMoveTips();
                        } else {
                            // 已经衔接，显示提示但不移动
                            console.log("音轨片段已衔接，无法继续移动");
                        }
                        
                        this.lastMoveP = canvasP;
                    }
                }else if(this.status == "stretch_left") {
                    let shadow = this.shadowCanvas.getChildAt(0);
                    let change = canvasP.x / this._interval - shadow.data.start;
                    let leftChange = this.checkLeft(shadow, change);
                    shadow.data.start += leftChange;
                    shadow.data.audioStart += leftChange;
                    shadow.x += leftChange * this._interval;
                    shadow.dirty();
                }else if(this.status == "stretch_right") {
                    let shadow = this.shadowCanvas.getChildAt(0);
                    let change = canvasP.x / this._interval - shadow.data.end;
                    let rightChange = this.checkRight(shadow, change);
                    shadow.data.end += rightChange;
                    shadow.dirty();
                }
            }
        }
    }

    onTrkDown(e) {
        let trk = e.currentTarget;
        if(trk && trk.selected) {
            if(trk.stretchMode) {
                let p = e.data.getLocalPosition(trk);
                if(p.x < 3) {
                    this.status = "stretch_left";
                    this.showShadow();
                }else {
                    this.status = "stretch_right";
                    this.showShadow();
                }
            }else {
                this.lastMoveP = e.data.getLocalPosition(this.canvas);
                this.status = "move";
            }
        }
    }

    onTrkUp(e) {
        let trk = e.currentTarget;
        if(trk) {
            this.hideTipsInfo();
            if(trk.stretchMode && (this.status == "stretch_left" || this.status == "stretch_right")) {
                trk.stretchMode = false;
                this.status = "normal";

                let shadow = this.shadowCanvas.getChildAt(0);
                PGlobal.m.send(SCENE, 6, 40, new proto.com.proto.scene.MAudioTrkParts(
                    [[[shadow.data.index, JSON.stringify(shadow.data, ["audioId", "audioStart", "audioTotal", "end", "start"])]]]));
                this.hideShadow();
            }else if(this.status == "move") {
                this.status = "normal";
                if(this.shadowCanvas.x != 0) {
                    let change = this.shadowCanvas.x / this._interval;
                    let datas = [];
                    let len = this.selected.length;
                    for(let i=0; i < len; ++i) {
                        let data = this.selected[i].data;
                        data.start += change;
                        data.end += change;
                        
                        // 确保不会移动到负数位置
                        if(data.start < 0) {
                            const offset = -data.start;
                            data.start = 0;
                            data.end += offset;
                        }
                        
                        datas.push([data.index, JSON.stringify(data, ["audioId", "audioStart", "audioTotal", "end", "start"])]);
                    }
                    PGlobal.m.send(SCENE, 6, 40, new proto.com.proto.scene.MAudioTrkParts([datas]));
                }
                this.hideShadow();
            }
        }
    }

    checkLeft(trk, change) {
        let result = change;
        if(result < 0) {
            if(trk.data.audioStart + result < 0) { //音频起始不能小于0
                result = -trk.data.audioStart;
            }
            if(trk.data.index > 0) { //不能跨越前一个
                let pre = this.getTrkByIndex(trk.data.index-1);
                if(pre && trk.data.start + result < pre.data.end) {
                    result = pre.data.end - trk.data.start;
                }
            }
        }else if(result > 0){ //不能小于最小值
            if(trk.data.start + result > trk.data.end - TRK_DURATION_MIN) {
                result = trk.data.end - TRK_DURATION_MIN - trk.data.start;
            }
        }
        return result;
    }

    checkRight(trk, change) {
        var result = change;
        if(result > 0) {
            var aft = this.getTrkByIndex(trk.data.index+1);
            if(aft && aft.data.start < trk.data.end + result) { //不能覆盖后面的
                result = aft.data.start - trk.data.end;
            }
            if(trk.data.audioStart + result > trk.data.audioTotal) { //不能超出音频总长度
                result = trk.data.audioTotal - trk.data.audioStart;
            }
        }else if(result < 0) {
            if(trk.data.end + result < trk.data.start + TRK_DURATION_MIN) {
                result = Math.min(0, trk.data.start + TRK_DURATION_MIN - trk.data.end);
            }
        }
        return result;
    }

    getTrkByIndex(index) {
        let result = undefined;
        if(index >= 0 && index < this.canvas.children.length) {
            result = this.canvas.getChildAt(index);
        }
        return result;
    }

    showShadow() {
        this.clearShadow();
        let len = this.selected.length;
        for(let i=0; i < len; ++i) {
            let data = Object.create(this.selected[i].data);
            let trk = this.getTrk(data, true);
            trk.range = this._range;
            trk.interactive = false;
            this.shadowCanvas.addChild(trk);
        }
    }

    hideShadow() {
        this.clearShadow();
    }

    removeSelected() {
        if(this.selected.length > 0) {
            let arr = [];
            let len = this.selected.length;
            let index;
            for(let i=0; i < len; ++i) {
                let trk = this.selected[i];
                index = this.canvas.getChildIndex(trk);
                arr.push(index);
                console.log("删除音轨片段, 索引: " + index.toString() + ", 片段ID: " + trk.data.audioId);
            }
            PGlobal.m.send(SCENE, 6, 39, new proto.com.proto.s.MInt32Array([arr]));
        }
    }

    /**
     * 使用方向键移动选中的音轨片段
     * @param {number} direction - 移动方向，-1表示向左，1表示向右
     */
    moveSelectedByKey(direction) {
        if(this.selected.length === 0) {
            return;
        }

        // 计算移动距离（单位：秒）
        // 可以根据需要调整步长，这里设置为0.1秒
        const moveStep = 0.1;
        const change = direction * moveStep;

        // 准备更新数据
        let datas = [];
        let len = this.selected.length;
        
        // 检查是否所有选中的片段都可以移动
        let canMove = true;
        for(let i=0; i < len; ++i) {
            let trk = this.selected[i];
            let newStart = trk.data.start + change;
            let newEnd = trk.data.end + change;
            
            // 检查边界：不能移动到负数位置
            if(newStart < 0) {
                canMove = false;
                break;
            }
            
            // 检查是否超出范围限制
            if(this._range.max !== Infinity && newEnd > this._range.max) {
                canMove = false;
                break;
            }
        }

        if(!canMove) {
            console.log("无法移动：超出边界");
            return;
        }

        // 执行移动
        for(let i=0; i < len; ++i) {
            let data = this.selected[i].data;
            data.start += change;
            data.end += change;
            datas.push([data.index, JSON.stringify(data, ["audioId", "audioStart", "audioTotal", "end", "start"])]);
        }

        // 发送更新消息到后端
        PGlobal.m.send(SCENE, 6, 40, new proto.com.proto.scene.MAudioTrkParts([datas]));
        
        console.log(`使用方向键移动音轨片段: ${direction > 0 ? '右' : '左'}, 步长: ${moveStep}秒`);
    }

    /**
     * 开始键盘连续移动
     * @param {number} direction - 移动方向，-1表示向左，1表示向右
     */
    startKeyMove(direction) {
        if(this.selected.length === 0) {
            return;
        }

        // 如果已经在移动，先停止
        this.stopKeyMove();

        // 设置移动方向
        this.keyMoveDirection = direction;

        // 立即执行一次移动
        this.executeKeyMove();

        // 启动定时器，持续移动
        this.keyMoveTimer = setInterval(() => {
            this.executeKeyMove();
        }, this.keyMoveInterval);
    }

    /**
     * 停止键盘连续移动
     */
    stopKeyMove() {
        if(this.keyMoveTimer) {
            clearInterval(this.keyMoveTimer);
            this.keyMoveTimer = null;
        }
        this.keyMoveDirection = 0;
    }

    /**
     * 获取指定音轨片段的前一个和后一个片段
     * @param {Object} targetTrk - 目标音轨片段
     * @returns {Object} {prev: 前一个片段, next: 后一个片段}
     */
    getAdjacentTrks(targetTrk) {
        if(!this.trks || !this.trks.parts) {
            return {prev: null, next: null};
        }

        const parts = this.trks.parts;
        let prev = null;
        let next = null;

        // 按start时间排序所有片段
        const sortedParts = parts.slice().sort((a, b) => a.start - b.start);
        
        // 找到目标片段的位置
        const targetIndex = sortedParts.findIndex(p => p.index === targetTrk.data.index);
        
        if(targetIndex > 0) {
            prev = sortedParts[targetIndex - 1];
        }
        if(targetIndex < sortedParts.length - 1) {
            next = sortedParts[targetIndex + 1];
        }

        return {prev, next};
    }

    /**
     * 检查移动是否会与其他片段碰撞，并计算最大可移动距离
     * @param {Array} selectedTrks - 选中的音轨片段数组
     * @param {number} change - 期望的移动距离（增量）
     * @param {number} accumulatedChange - 已累积的移动距离（可选，用于鼠标拖动）
     * @returns {Object} {canMove: 是否可以移动, actualChange: 实际可移动距离, shouldSnap: 是否应该衔接}
     */
    checkCollision(selectedTrks, change, accumulatedChange = 0) {
        if(!this.trks || !this.trks.parts) {
            return {canMove: true, actualChange: change, shouldSnap: false};
        }

        let actualChange = change;
        let shouldSnap = false;
        const tolerance = 0.00; // 衔接容差（秒），值越小越精确，设置为0表示精确对齐

        // 获取所有未选中的片段
        const selectedIndices = new Set(selectedTrks.map(t => t.data.index));
        const unselectedParts = this.trks.parts.filter(p => !selectedIndices.has(p.index));

        // 检查每个选中的片段
        for(let selectedTrk of selectedTrks) {
            // 计算当前实际位置（原始位置 + 已累积的移动）
            const currentStart = selectedTrk.data.start + accumulatedChange;
            const currentEnd = selectedTrk.data.end + accumulatedChange;
            
            // 计算新位置
            const newStart = currentStart + change;
            const newEnd = currentEnd + change;

            // 检查是否移动到负数位置
            if(newStart < 0) {
                actualChange = -currentStart;
                shouldSnap = true;
                continue;
            }

            // 检查与未选中片段的碰撞
            for(let otherPart of unselectedParts) {
                if(change > 0) {
                    // 向右移动：检查是否会碰到后面的片段
                    if(newEnd > otherPart.start && currentEnd <= otherPart.start) {
                        // 计算到碰撞点的距离
                        const maxChange = otherPart.start - currentEnd;
                        if(maxChange < actualChange) {
                            actualChange = maxChange;
                            shouldSnap = true;
                        }
                    }
                } else if(change < 0) {
                    // 向左移动：检查是否会碰到前面的片段
                    if(newStart < otherPart.end && currentStart >= otherPart.end) {
                        // 计算到碰撞点的距离
                        const maxChange = otherPart.end - currentStart;
                        if(Math.abs(maxChange) < Math.abs(actualChange)) {
                            actualChange = maxChange;
                            shouldSnap = true;
                        }
                    }
                }
            }
        }

        // 如果实际移动距离很小，认为已经衔接
        const canMove = Math.abs(actualChange) > tolerance;

        return {canMove, actualChange, shouldSnap};
    }

    /**
     * 执行一次键盘移动
     */
    executeKeyMove() {
        if(this.keyMoveDirection === 0 || this.selected.length === 0) {
            return;
        }

        // 计算移动距离（单位：秒）
        const moveStep = 0.1;
        const change = this.keyMoveDirection * moveStep;

        // 检查碰撞并获取实际可移动距离
        const collisionResult = this.checkCollision(this.selected, change);
        
        if(!collisionResult.canMove) {
            // 无法移动或已经衔接，停止移动
            this.stopKeyMove();
            console.log("音轨片段已衔接或到达边界，停止移动");
            return;
        }

        // 使用实际可移动距离
        const actualChange = collisionResult.actualChange;

        // 准备更新数据
        let datas = [];
        let len = this.selected.length;

        // 执行移动
        for(let i=0; i < len; ++i) {
            let data = this.selected[i].data;
            data.start += actualChange;
            data.end += actualChange;
            
            // 确保不会移动到负数位置
            if(data.start < 0) {
                const offset = -data.start;
                data.start = 0;
                data.end += offset;
            }
            
            datas.push([data.index, JSON.stringify(data, ["audioId", "audioStart", "audioTotal", "end", "start"])]);
        }

        // 发送更新消息到后端
        PGlobal.m.send(SCENE, 6, 40, new proto.com.proto.scene.MAudioTrkParts([datas]));

        // 如果发生了衔接，停止移动
        if(collisionResult.shouldSnap) {
            this.stopKeyMove();
            console.log("音轨片段已衔接，停止移动");
        }
    }

    set interval(value) {
        this._interval = value;
        this._updateWidth();
        this.dirty();
    }

    startInfoTimeout(trk, x){
        this.hideTipsInfo();
        this.hoverTimeout = setTimeout(()=>{this._showTrkInfo(trk, x)}, 600);
    }

    _showTrkInfo(trk, x){
        this.hideTipsInfo();
        const data = trk.data;
        const time = data.end - data.start;
        let info = this._getTimeString(time);
        info += "\n";
        info += this._getTimeString(data.start) + " - " + this._getTimeString(data.end);
        this.showTipsInfo(info, x + 2);
    }

    _showMoveTips(){
        let change = this.shadowCanvas.x / this._interval;
        let info = this._getTimeString(Math.abs(change));
        const sign = change > 0 ? "+" : "-";
        this.hideTipsInfo();
        this.showTipsInfo(sign + info, this.startMoveX);
    }

    _getTimeString(time){
        let s = Math.floor(time);
        const frac = Math.floor((time - s) * 100)
        const minu = Math.floor(s / 60);
        s = s - minu * 60;
        return this._formatNumString(minu, 2) + ":" + this._formatNumString(s, 2) + ":" + this._formatNumString(frac, 2)
    }

    _formatNumString(num, cnt, stuff){
        stuff = stuff || "0";
        num = Math.floor(num);
        let s = num.toString();
        const base = Math.pow(10, cnt - 1);
        if(num < base){
            const cur = (num > 0 ? Math.floor(Math.log10(num)) : 0) + 1;
            stuff = stuff.repeat(cnt - cur);
            s = stuff + s;
        }
        return s;
    }

    _mergeStyle(style){
        var def = new PIXI.TextStyle({
            fontSize : 12,
            fontFamily: "Arial",
            lineHeight : 12,
        });
        for(let k in style || {}){
            def[k] = style[k];
        }
        return def;
    }

    showTipsInfo(text, x, y, style, paddings){
        style = this._mergeStyle(style);
        paddings = paddings || [2, 4, 2, 4];
        if(!this.tipsWidget){
            this.tipsWidget = new TipsWidget();
            this.tipsWidget.pivot = {x: 0, y:1};
        }
        const tips = this.tipsWidget;
        tips.text = text;
        tips.textStyle = style;
        tips.paddings = paddings;
        tips.x = x || 0;
        tips.y = y || TIP_Y;
        this.addChild(tips);
    }
    hideTipsInfo(){
        if(this.tipsWidget && this.tipsWidget.parent){
            this.tipsWidget.parent.removeChild(this.tipsWidget);
        }
        if(this.hoverTimeout != null){
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/AudioTrks.js